import React from   "react";
import { ListImageItem } from "./lists";
function ImageVisor({route}) {
  return (
      <ListImageItem imageUrl={route.params.imageUrl}/>
  );
}
export default  ImageVisor